import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild} from '@angular/core';
import {checkStatus, NewSubAccountRequest} from '../../../models/new-sub-account-request';
import {ApiAgentService} from '../../../services/api-agent.service';
import {NewSubAccountDetailsComponent} from '../new-sub-account-details/new-sub-account-details.component';
import {SubAccountsAssignmentFormComponent} from '../sub-accounts-assignment-form/sub-accounts-assignment-form.component';
import {Router, RouterModule} from '@angular/router';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-new-sub-accounts-request-list',
  templateUrl: './new-sub-accounts-request-list.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, NewSubAccountDetailsComponent, RouterModule],
  styleUrls: ['./new-sub-accounts-request-list.component.scss']
})
export class NewSubAccountsRequestListComponent implements OnInit {

  @ViewChild('newSubAccountDetails') newSubAccountDetails: NewSubAccountDetailsComponent;
  @ViewChild('subAccountsAssignmentForm') subAccountsAssignmentForm: SubAccountsAssignmentFormComponent;

  loading: boolean;
  newSubAccountsRequests: NewSubAccountRequest[];

  constructor(private api: ApiAgentService, private routing: Router, private loader: GlobalLoaderService) {
  }

  ngOnInit(): void {
    this.newSubAccountsRequests = [];
    this.loading = true;
    setTimeout(async () => {
      await this.loadResources();
      this.newSubAccountsRequests = await this.api.getSubAccountRequests();
      this.loading = false;
    }, 1000);
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/assets/css/forms/theme-checkbox-radio.css');
    await this.loader.loadExternalStyles('/plugins/jquery-ui/jquery-ui.min.css');
    await this.loader.loadExternalStyles('/assets/css/apps/contacts.css');
    await this.loader.loadExternalScript('/plugins/jquery-ui/jquery-ui.min.js');
    await this.loader.loadExternalScript('/assets/js/apps/contact.js');
  }


  checkStatus(newSubAccountRequest: NewSubAccountRequest) {
    return checkStatus(newSubAccountRequest);
  }

  // checkStatus(newSubAccountRequest: NewSubAccountRequest) {
  //   if (!newSubAccountRequest.approved && !newSubAccountRequest.rejectReason && !newSubAccountRequest.usedInvoice) {
  //     return "Pending Approval";
  //   } else if (!newSubAccountRequest.approved && !newSubAccountRequest.rejectReason && !newSubAccountRequest.paymentDate && newSubAccountRequest.usedInvoice) {
  //     return "Cancelled";
  //   } else if (newSubAccountRequest.approved && !newSubAccountRequest.paymentDate) {
  //     return "Pending Payment";
  //   } else if (!newSubAccountRequest.approved && newSubAccountRequest.rejectReason) {
  //     return "Rejected";
  //   } else if (newSubAccountRequest.approved && newSubAccountRequest.paymentDate && !newSubAccountRequest.usedInvoice) {
  //     return "Ready To Use";
  //   } else if (newSubAccountRequest.approved && newSubAccountRequest.paymentDate && newSubAccountRequest.usedInvoice) {
  //     return "Used";
  //   }
  // }

  viewRequest(newSubAccountRequest: NewSubAccountRequest) {
    this.newSubAccountDetails.openModal(newSubAccountRequest);
  }

  payRequest(newSubAccountRequest: NewSubAccountRequest) {
    this.newSubAccountDetails.openModal(newSubAccountRequest);
    this.newSubAccountDetails.payRequest();
  }

  viewUsed(newSubAccountRequest: NewSubAccountRequest) {
    this.routing.navigateByUrl('/private/assign-sub-accounts/' + newSubAccountRequest.id + '/requests').then();
  }

  useRequest(newSubAccountRequest: NewSubAccountRequest) {
    this.routing.navigateByUrl('/private/assign-sub-accounts/' + newSubAccountRequest.id + '/requests').then();
  }

  cancelRequest(newSubAccountRequest: NewSubAccountRequest) {
    this.newSubAccountDetails.openModal(newSubAccountRequest);
    this.newSubAccountDetails.cancelRequest();
  }

}
